import { COIN } from "@/lib/constants";
import { FaXTwitter, FaTelegram } from "react-icons/fa6";
import { Rocket } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const nav = [
    { key: "mission",    href: "#about" },
    { key: "tokenomics", href: "#tokenomics" },
    { key: "roadmap",    href: "#roadmap" },
    { key: "faq",        href: "#faq" },
  ];
  const channels = [
    { key: "telegram", href: COIN.socials.telegram },
    { key: "twitter",  href: COIN.socials.twitter },
    { key: "pumpfun",  href: COIN.socials.pumpfun },
    { key: "dex",      href: COIN.socials.dex },
  ];

  return (
    <footer id="footer" data-testid="site-footer" className="relative border-t border-primary/20 bg-black">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-3 gap-10 mb-14">
          <div>
            <p className="font-mono-alt text-[10px] tracking-[0.3em] text-secondary">{t("footer.section_label")}</p>
            <p className="mt-3 font-display font-bold text-lg">
              {t("footer.transmitting_from", { network: COIN.network })}
            </p>
            <p className="mt-2 text-sm text-muted-foreground max-w-sm">{t("footer.disclaimer")}</p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <div>
              <p className="font-mono-alt text-[10px] tracking-widest text-muted-foreground mb-3">{t("footer.nav_label")}</p>
              <ul className="space-y-2 text-sm">
                {nav.map((n) => (
                  <li key={n.key}><a className="hover:text-primary transition-colors" href={n.href}>{t(`footer.nav.${n.key}`)}</a></li>
                ))}
              </ul>
            </div>
            <div>
              <p className="font-mono-alt text-[10px] tracking-widest text-muted-foreground mb-3">{t("footer.channels_label")}</p>
              <ul className="space-y-2 text-sm">
                {channels.map((c) => (
                  <li key={c.key}><a className="hover:text-primary transition-colors" href={c.href} target="_blank" rel="noreferrer">{t(`footer.channels.${c.key}`)}</a></li>
                ))}
              </ul>
            </div>
          </div>

          <div>
            <p className="font-mono-alt text-[10px] tracking-widest text-muted-foreground mb-3">{t("footer.follow_label")}</p>
            <div className="flex gap-3">
              {[
                { Icon: FaTelegram, href: COIN.socials.telegram, label: "Telegram" },
                { Icon: FaXTwitter, href: COIN.socials.twitter, label: "X" },
                { Icon: Rocket, href: COIN.socials.pumpfun, label: "Pumpfun" },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-sm border border-primary/40 text-primary hover:bg-primary/10 transition-colors"
                >
                  <s.Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
            <p className="mt-6 font-mono-alt text-[10px] tracking-widest text-muted-foreground">{t("footer.contract_label")}</p>
            <code className="mt-2 block font-mono-alt text-xs text-primary break-all">{COIN.contract}</code>
          </div>
        </div>

        <div className="border-t border-primary/15 pt-10 overflow-hidden">
          <p
            aria-hidden
            className="font-display font-black tracking-tighter stroke-text text-center leading-none"
            style={{ fontSize: "clamp(3.5rem, 18vw, 16rem)" }}
          >
            UFO/COIN
          </p>
        </div>

        <div className="mt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-muted-foreground font-mono-alt">
          <p>{t("footer.rights", { year, name: COIN.name })}</p>
          <p className="max-w-xl md:text-right">{t("footer.meme_notice")}</p>
        </div>
      </div>
    </footer>
  );
}
